import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';
import { CatHeading } from '@blocks-react/components/Heading';
import { ErrorBanner } from '../../common';

type ServiceRecommendationErrorProps = {
  errorHeader: string;
  errorContent: string;
};

export const ServiceRecommendationError = ({
  errorHeader = '',
  errorContent = '',
}: ServiceRecommendationErrorProps) => {
  return (
    <ErrorBanner heading={errorHeader}>
      <CatHeading variant="body-sm">{errorContent}</CatHeading>
      <CatIconWarningCircle slot="before" />
    </ErrorBanner>
  );
};
